import * as React from 'react'

export default () => (
  <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="33" cy="33" r="32" stroke="#8FB4FF" />
    <path d="M33 17L33 42" stroke="#8FB4FF" strokeWidth="2" />
    <path d="M33 46V49" stroke="#8FB4FF" strokeWidth="2" />
  </svg>
)
